import { DocumentTextIcon } from '@heroicons/react/24/outline';

const sections = [
  {
    title: '1. Acceptance of Terms',
    content: 'By accessing and participating in the Ibom Open Golf Tournament ("Tournament"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not participate in the Tournament.',
  },
  {
    title: '2. Tournament Registration',
    items: [
      'Registration is subject to availability and is on a first-come, first-served basis.',
      'All participants must meet the eligibility criteria as specified in the Tournament rules.',
      'Registration fees are non-refundable unless the Tournament is cancelled by the organizers.',
    ],
  },
  {
    title: '3. Player Conduct',
    items: [
      'All players must adhere to the Rules of Golf as approved by R&A and USGA.',
      'Players must maintain professional conduct throughout the Tournament.',
      'The Tournament committee reserves the right to disqualify any player for misconduct.',
    ],
  },
  {
    title: '4. Tournament Format',
    items: [
      'The Tournament format and schedule are subject to change at the discretion of the organizers.',
      'Weather-related adjustments may be made to ensure player safety and fair competition.',
    ],
  },
  {
    title: '5. Prize Money and Awards',
    items: [
      'Prize money will be distributed according to the official prize breakdown structure.',
      'All prizes are subject to applicable taxes and regulations.',
    ],
  },
  {
    title: '6. Media Rights',
    items: [
      'The Tournament reserves all media rights including photographs, video, and digital content.',
      'Players grant permission for use of their image and likeness for promotional purposes.',
    ],
  },
  {
    title: '7. Liability and Insurance',
    items: [
      'Players participate at their own risk and are responsible for their own insurance coverage.',
      'The Tournament organizers are not liable for any injury, loss, or damage to players or their equipment.',
    ],
  },
  {
    title: '8. Cancellation Policy',
    items: [
      'The Tournament may be cancelled or postponed due to circumstances beyond our control.',
      'In case of cancellation, the refund policy will be communicated to all registered players.',
    ],
  },
  {
    title: '9. Amendments',
    content: 'The Tournament organizers reserve the right to amend these Terms at any time. Changes will be communicated to registered players and posted on the official website.',
  },
  {
    title: '10. Contact Information',
    content: 'For questions about these Terms, please contact:\nTournament Director\nIbom Golf & Country Club\nUyo, Akwa Ibom State, Nigeria\nEmail: legal@ibomopen.com',
  },
];

export default function MobileTerms() {
  return (
    <div className="pb-10">
      {/* Header */}
      <div className="bg-golf-gray px-4 pt-4 pb-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center">
            <DocumentTextIcon className="w-5 h-5 text-golf-orange" />
          </div>
          <h1 className="text-white font-display font-bold text-xl">Terms of Service</h1>
        </div>
        <p className="text-golf-sand text-xs">Last updated: March 15, 2025</p>
      </div>

      <div className="px-4 pt-4 flex flex-col gap-4">
        {sections.map((section, i) => (
          <div key={i} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4">
            <h2 className="font-display font-bold text-golf-gray text-sm mb-2">{section.title}</h2>
            {section.content && (
              <p className="text-xs text-gray-500 leading-relaxed whitespace-pre-line">{section.content}</p>
            )}
            {section.items && (
              <ul className="space-y-2">
                {section.items.map((item, ii) => (
                  <li key={ii} className="flex items-start gap-2 text-xs text-gray-500">
                    <span className="w-1.5 h-1.5 rounded-full bg-golf-orange mt-1.5 flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}

        <p className="text-center text-xs text-gray-300 mt-2">
          © 2004 – {new Date().getFullYear()} Ibom Open. All rights reserved.
        </p>
      </div>
    </div>
  );
}
